import React, {useState, useEffect} from "react";
import * as Sentry from '@sentry/browser';
import DateRange from "../Utils/DateRange";
import Api from "../../Api";
import classes from "./antiFraudFilters.module.css";

function AntiFraudFilters({onApplyFilters, accountAccessSettings, isLoading, token}) {
    var [dateRange, setDateRange] = useState({});
    var [project, setProject] = useState("");
    var [result, setResult] = useState("");
    var [checkType, setCheckType] = useState("");
    var [clientIp, setClientIp] = useState("");
    var [phone, setPhone] = useState("");
    var [card, setCard] = useState("");
    var [merchants, setMerchants] = useState([]);

    // Загружаем список мерчантов через getProjects (как в Transactions)
    useEffect(function () {
        if (!token) return;
        var api = new Api({token: token});
        api.getProjects().then(function (data) {
            if (Array.isArray(data)) {
                var list = data.map(function (p) {
                    return {uuid: p.uuid, name: p.displayName || p.name || p.uuid};
                });
                setMerchants(list);
            }
        }).catch(function (err) {
            Sentry.captureException(err);
        });
    }, [token]);

    function handleApply() {
        var filters = {
            dateRange: dateRange
        };
        if (project) {
            filters.projects = [project];
        }
        if (result) {
            filters.result = result;
        }
        if (checkType) {
            filters.checkType = checkType;
        }
        if (clientIp.trim()) {
            filters.clientIp = clientIp.trim();
        }
        if (phone.trim()) {
            filters.phone = phone.trim();
        }
        if (card.trim()) {
            filters.card = card.trim();
        }
        onApplyFilters(filters);
    }

    function handleReset() {
        setProject("");
        setResult("");
        setCheckType("");
        setClientIp("");
        setPhone("");
        setCard("");
        setDateRange({});
        onApplyFilters({});
    }

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                <div className={classes.Group}>
                    <span className={classes.Label}>Период</span>
                    <DateRange onSelectDate={function (range) { setDateRange(range); }} defaultPeriod="week"/>
                </div>

                <div className={classes.Row}>
                    <div className={classes.Group}>
                        <span className={classes.Label}>Мерчант</span>
                        <select
                            className={classes.Select}
                            value={project}
                            onChange={function (e) { setProject(e.target.value); }}
                        >
                            <option value="">Все</option>
                            {merchants.map(function (m) {
                                return (
                                    <option key={m.uuid} value={m.uuid}>{m.name}</option>
                                );
                            })}
                        </select>
                    </div>

                    <div className={classes.Group}>
                        <span className={classes.Label}>Результат</span>
                        <select
                            className={classes.Select}
                            value={result}
                            onChange={function (e) { setResult(e.target.value); }}
                        >
                            <option value="">Все</option>
                            <option value="ok">ОК</option>
                            <option value="blocked">Заблокировано</option>
                            <option value="error">Ошибка</option>
                        </select>
                    </div>

                    <div className={classes.Group}>
                        <span className={classes.Label}>Тип проверки</span>
                        <select
                            className={classes.Select}
                            value={checkType}
                            onChange={function (e) { setCheckType(e.target.value); }}
                        >
                            <option value="">Все</option>
                            <option value="payment">Платёж</option>
                            <option value="payout">Выплата</option>
                        </select>
                    </div>
                </div>

                <div className={classes.Row}>
                    <div className={classes.Group}>
                        <span className={classes.Label}>IP</span>
                        <input
                            className={classes.Input}
                            type="text"
                            placeholder="Введите IP"
                            value={clientIp}
                            onChange={function (e) { setClientIp(e.target.value); }}
                        />
                    </div>

                    <div className={classes.Group}>
                        <span className={classes.Label}>Телефон</span>
                        <input
                            className={classes.Input}
                            type="text"
                            placeholder="Введите телефон"
                            value={phone}
                            onChange={function (e) { setPhone(e.target.value); }}
                        />
                    </div>

                    <div className={classes.Group}>
                        <span className={classes.Label}>Номер карты</span>
                        <input
                            className={classes.Input}
                            type="text"
                            placeholder="Маска карты"
                            value={card}
                            onChange={function (e) { setCard(e.target.value); }}
                        />
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button
                    className={classes.Btn}
                    onClick={handleApply}
                    disabled={isLoading}
                >
                    Применить
                </button>
                <button
                    className={classes.BtnReset}
                    onClick={handleReset}
                >
                    Сбросить
                </button>
            </div>
        </div>
    );
}

export default AntiFraudFilters;



// WEBPACK FOOTER //
// ./src/Components/AntiFraudFilters/index.js